import { z } from "zod";

const SafekeyAuthenticationStatusType = z.enum([
  "CHALLENGE_REQUIRED",
  "AUTHENTICATION_SUCCESSFUL",
  "ATTEMPTS_PROCESSING_PERFORMED",
  "DECOUPLED_AUTHENTICATION_CONFIRMED",
  "NOT_AUTHENTICATED_TRANSACTION_DENIED",
  "INFO_ONLY_ACK",
  "AUTHENTICATION_COULD_NOT_BE_PERFORMED",
  "AUTHENTICATION_REJECTED",
  "NOT_ENROLLED",
]);

const SafekeyAuthorizationStatusType = z.enum([
  "AUTHORIZATION_SUCCESSFUL",
  "AUTHORIZATION_DENIED",
  "REVERSAL_ADVICE_SUCCESSFUL",
  "REVERSAL_ADVICE_FAILED",
]);

const SafekeyResponseSchema = z
  .object({
    acsURL: z.string(),
    approved: z.boolean(),
    acsTransID: z.string(),
    authenticationStatus: SafekeyAuthenticationStatusType,
    authorizationStatus: SafekeyAuthorizationStatusType.nullable().optional(),
    threeDSServerTransID: z.string(),
  })
  .transform((api) => ({
    acsUrl: api.acsURL,
    approved: api.approved,
    transactionId: api.acsTransID,
    authenticationStatus: api.authenticationStatus,
    authorizationStatus: api.authorizationStatus,
    serverTransactionId: api.threeDSServerTransID,
  }));

type SafekeyResponse = z.infer<typeof SafekeyResponseSchema>;
type SafekeyAuthenticationStatus = z.infer<
  typeof SafekeyAuthenticationStatusType
>;
type SafekeyAuthorizationStatus = z.infer<
  typeof SafekeyAuthorizationStatusType
>;

export {
  SafekeyResponseSchema,
  type SafekeyResponse,
  type SafekeyAuthenticationStatus,
  type SafekeyAuthorizationStatus,
};
